import { includes } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { compose } from 'redux';
import { ChanelConfig } from '../../../../../configs/GlobalConfig';
import MessageHub from '../../../../../core/signalr/SignalrMessageHub';
import { cellNegtiveRed } from '../../../../common/table/CustomCellTable';
import Table from '../../../../common/table/Table';
import TextBlink from '../../../../common/table/TextBlink';
import TradingViewUrl from '../../../../common/TradingViewUrl';
import { getColorPrice } from '../../../../helpers/Color';
import { getDataFollowKeyByDot, getRanking } from '../../../../helpers/Common';
import {
  formatPrice,
  formatTextFloat,
  formatVolume,
  formatPercent,
} from '../../../../helpers/Text';
import CellHover from '../../../../market/watchlist/summary/CellHover';
import RowClick from '../../../../common/RowClick';
import {
  REDUCER_NAME,
  subscribeRealtimeTickAccumulation,
  subscribeRealtimeTickBreakout,
  subscribeRealtimeTickBreakoutMa,
  subscribeRealtimeTickBestDown,
  loadMoreData,
} from '../reducer';
import Const from '../Const';

const getClassName = (item, listColumn) => {
  return getColorPrice(
    getDataFollowKeyByDot(item, listColumn.PRICE),
    getDataFollowKeyByDot(item, listColumn.REF_PRICE),
    getDataFollowKeyByDot(item, listColumn.CEILING_PRICE),
    getDataFollowKeyByDot(item, listColumn.FLOOR_PRICE),
    'text',
  );
};

class TaStrategyTable extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pageSize: 50,
    };
    this.tableRef = React.createRef();
  }

  componentDidMount() {
    MessageHub.subscribe(ChanelConfig.TickChanel, this.dispatchDataRealtime);
  }

  dispatchDataRealtime = data => {
    const {
      subscribeRealtimeTickAccumulation,
      subscribeRealtimeTickBreakout,
      subscribeRealtimeTickBreakoutMa,
      subscribeRealtimeTickBestDown,
      currentTab,
    } = this.props;
    if (currentTab === 1) {
      subscribeRealtimeTickAccumulation(data);
    }
    if (currentTab === 2) {
      subscribeRealtimeTickBreakout(data);
    }
    if (currentTab === 3) {
      subscribeRealtimeTickBreakoutMa(data);
    }
    if (currentTab === 4) {
      subscribeRealtimeTickBestDown(data);
    }
  };

  getIds = () => {
    const {
      currentTab,
      listDataAccumulationTicker,
      listDataBreakoutTicker,
      listDataBreakoutMaTicker,
      listDataBestDownTrendTicker,
    } = this.props;
    if (currentTab === 1) {
      return listDataAccumulationTicker;
    }
    if (currentTab === 2) {
      return listDataBreakoutTicker;
    }
    if (currentTab === 3) {
      return listDataBreakoutMaTicker;
    }
    if (currentTab === 4) {
      return listDataBestDownTrendTicker;
    }

    return listDataAccumulationTicker;
  };

  handleScroll = e => {
    const { totalPage, loadMoreData, page, isLoading, currentTab } = this.props;
    const bottom =
      e.target.scrollHeight - Math.round(e.target.scrollTop) ===
      e.target.clientHeight;

    if (page >= totalPage || isLoading) return;
    if (bottom) {
      const newpage = page + 1;
      loadMoreData(newpage, currentTab);
    }
  };

  componentWillReceiveProps(nextProps) {
    const { page } = this.props;
    if (nextProps.page === 1 && page !== nextProps.page) {
      this.resetScroll();
    }
  }

  resetScroll = () => {
    this.tableRef.current.scrollToTop();
  };

  getDataFromRedux = () => {
    const { currentTab } = this.props;
    if (currentTab === 1) {
      return state => state[REDUCER_NAME].listObjectDataAccumulationByTicker;
    }
    if (currentTab === 2) {
      return state => state[REDUCER_NAME].listObjectDataBreakoutByTicker;
    }
    if (currentTab === 3) {
      return state => state[REDUCER_NAME].listObjectDataBreakoutMaByTicker;
    }
    if (currentTab === 4) {
      return state => state[REDUCER_NAME].listObjectDataBestDownTrendByTicker;
    }
    return state => state[REDUCER_NAME].listObjectDataAccumulationByTicker;
  };

  getSchema = () => {
    const { title: tabTitle, schemaKey, breakOutType } = this.props;

    return Object.keys(schemaKey).map((item, index) => {
      const key = schemaKey[item];
      const title = `${tabTitle}.${item}`;
      const result = {
        key,
        title,
      };

      if (index === 0) {
        return {
          ...result,
          isString: true,
          render: (text, item) => (
            <CellHover organCode={item.organCode} isShowDeleteIcon={false}>
              <TextBlink item={item} tradingDate="tradingDate">
                <TradingViewUrl code={item.organCode} />
                &nbsp;{text}
              </TextBlink>
            </CellHover>
          ),
        };
      }

      if (
        includes(
          [
            schemaKey.VOL,
            schemaKey.VOL_PREVIOUS,
            schemaKey.VOL_AVG,
            schemaKey.AVG_VOL_1M,
          ],
          key,
        )
      ) {
        return {
          ...result,
          thTooltip: this.getThToolTip(key),
          render: (text, item) => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {formatTextFloat(formatVolume(text))}
              </TextBlink>
            );
          },
        };
      }

      if (includes([schemaKey.PRICE_PREV, schemaKey.PRICE_AVG], key)) {
        return {
          ...result,
          thTooltip: this.getThToolTip(key),
          render: (text, item) => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {formatTextFloat(formatPrice(text))}
              </TextBlink>
            );
          },
        };
      }

      if (includes([schemaKey.PRICE], key)) {
        return {
          ...result,
          render: (text, item) => {
            const className = getClassName(item, schemaKey);
            return (
              <TextBlink
                item={item}
                tradingDate="tradingDate"
                className={className}
              >
                {formatTextFloat(formatPrice(text))}
              </TextBlink>
            );
          },
        };
      }

      if (includes([schemaKey.RSI14], key)) {
        return {
          ...result,
          render: text => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {formatTextFloat(text)}
              </TextBlink>
            );
          },
        };
      }

      if (
        includes([schemaKey.RETURN_DOWNTREND, schemaKey.RETURN_RECOVERY], key)
      ) {
        return {
          ...result,
          thTooltip: this.getThToolTip(key),
          render: text => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {`${formatTextFloat(formatPercent(text))}%`}
              </TextBlink>
            );
          },
        };
      }

      if (
        includes(
          [
            schemaKey.MA20,
            schemaKey.MA5,
            schemaKey.MA50,
            schemaKey.MA100,
            schemaKey.MA200,
          ],
          key,
        )
      ) {
        return {
          ...result,
          render: text => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {formatTextFloat(formatPrice(text))}
              </TextBlink>
            );
          },
        };
      }

      if (includes([schemaKey.PE, schemaKey.PB], key)) {
        return {
          ...result,
          render: (text, item) => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {cellNegtiveRed(text)}
              </TextBlink>
            );
          },
        };
      }

      if (breakOutType === Const.filterBreakout.breakOutType.TOP) {
        if (includes([schemaKey.TOP_PREVIOUS], key)) {
          return {
            ...result,
            thTooltip: this.getThToolTip(key),
            render: (text, item) => {
              const high = getDataFollowKeyByDot(item, schemaKey.HIGHEST);
              const low = getDataFollowKeyByDot(item, schemaKey.LOWEST);
              return (
                <TextBlink item={item} tradingDate="tradingDate">
                  {formatTextFloat(high / low)}
                </TextBlink>
              );
            },
          };
        }
      }

      if (breakOutType === Const.filterBreakout.breakOutType.BOTTOM) {
        if (includes([schemaKey.BOTTOM_PREVIOUS], key)) {
          return {
            ...result,
            thTooltip: this.getThToolTip(key),
            render: (text, item) => {
              const high = getDataFollowKeyByDot(item, schemaKey.HIGHEST);
              const low = getDataFollowKeyByDot(item, schemaKey.LOWEST);
              return (
                <TextBlink item={item} tradingDate="tradingDate">
                  {formatTextFloat(high / low)}
                </TextBlink>
              );
            },
          };
        }
      }

      if (includes([schemaKey.RANKING], key)) {
        return {
          ...result,
          disableResize: true,
          thTooltip: I18n.t('table.strategy.ranking'),
          render: (rank, item) => {
            const totalRank = getDataFollowKeyByDot(item, schemaKey.TOTAL_RANK);
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {getRanking(rank, totalRank)}
              </TextBlink>
            );
          },
        };
      }

      return {
        ...result,
        render: text => <TextBlink>{formatTextFloat(text)}</TextBlink>,
      };
    });
  };

  getThToolTip = key => {
    const { schemaKey } = this.props;
    if (schemaKey.PRICE_PREV === key) {
      return I18n.t('table.strategy.pricePrev', {
        x: this.getCurrentParamThToolTip(),
      });
    }

    if (schemaKey.VOL_PREVIOUS === key) {
      return I18n.t('table.strategy.volPrev', {
        x: this.getCurrentParamThToolTip(),
      });
    }

    if (schemaKey.TOP_PREVIOUS === key) {
      return I18n.t('table.strategy.topPrev', {
        x: this.getCurrentParamThToolTip(),
      });
    }

    if (schemaKey.BOTTOM_PREVIOUS === key) {
      return I18n.t('table.strategy.bottomPrev', {
        x: this.getCurrentParamThToolTip(),
      });
    }

    if (schemaKey.RETURN_DOWNTREND === key) {
      return I18n.t('table.strategy.returnDownTrend', {
        x: this.getCurrentParamThToolTip(),
      });
    }

    if (schemaKey.RETURN_RECOVERY === key) {
      return I18n.t('table.strategy.returnRecovery', {
        x: this.getCurrentParamThToolTip(),
      });
    }

    return null;
  };

  getCurrentParamThToolTip = () => {
    const { filterData, currentTab } = this.props;
    if (currentTab === 1) {
      return filterData[currentTab].filterLineOne;
    }

    if (currentTab === 2 || currentTab === 4) {
      return I18n.t(`table.strategy.${filterData[currentTab].filterLineOne}`);
    }

    return null;
  };

  render() {
    const { isLoading, listHideColumn, onSort } = this.props;

    return (
      <RowClick>
        {onRowClick => (
          <Table
            onSort={onSort}
            clickRow={onRowClick}
            scrollRef={this.tableRef}
            thValign="top"
            isLoading={isLoading}
            ids={this.getIds()}
            resizable={true}
            columnDraggable={false}
            rowDraggable={false}
            onScrollFunction={this.handleScroll}
            hideColumns={listHideColumn}
            getDataFromRedux={this.getDataFromRedux()}
            schema={this.getSchema()}
          />
        )}
      </RowClick>
    );
  }
}

const mapStateToProps = state => {
  return {
    listDataAccumulationTicker: state[REDUCER_NAME].listDataAccumulationTicker,
    listDataBreakoutTicker: state[REDUCER_NAME].listDataBreakoutTicker,
    listDataBreakoutMaTicker: state[REDUCER_NAME].listDataBreakoutMaTicker,
    listDataBestDownTrendTicker:
      state[REDUCER_NAME].listDataBestDownTrendTicker,
    isLoading: state[REDUCER_NAME].isLoading,
    totalPage: state[REDUCER_NAME].totalPage,
    page: state[REDUCER_NAME].page,

    breakOutType:
      state[REDUCER_NAME].filterData[state[REDUCER_NAME].currentTabData]
        .breakOutType,
    i18n: state.i18n,
  };
};

const mapDispatchToProps = {
  subscribeRealtimeTickAccumulation,
  subscribeRealtimeTickBreakout,
  subscribeRealtimeTickBreakoutMa,
  subscribeRealtimeTickBestDown,
  loadMoreData,
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);

export default enhance(TaStrategyTable);
